import styled from 'styled-components'

export const Pagination = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 20px;

  .pagination-btn {
    background-color: transparent;
    border-color: transparent;
    border-radius: 5px;
    width: 35px;
    height: 35px;
    cursor: pointer;
    color: #333;
    font-size: 16px;
    transition: background-color 0.3s;
  }

  .pagination-btn-action {
    background-color: transparent;
    border: 2px solid #53737A;
    border-radius: 5px;
    width: 45px;
    height: 45px;
    cursor: pointer;
    color: #53737A;
    font-size: 16px;
    transition: background-color 0.3s;
    padding:5px;
  }

  .pagination-btn-action:disabled {
    background-color: transparent;
    border: 2px solid #BBC7C9;
    color: #BBC7C9;
    cursor: not-allowed;
    padding:5px;
  }
  
  
  .pagination-btn:hover {
    background-color: #e0e0e0;
  }
  
  .pagination-btn:disabled {
    background-color: transparent;
    color: #aaa;
    cursor: not-allowed;
  }
  
  .pagination-btn.active {
    background-color: transparent;
    color: black;
    border-color: transparent;
    text-decoration: underline;
  }
`

  
  